<template>
  <Details :compName="$t('recommended')"></Details>
</template>

<script>
import Details from "@/components/widgets/ProductDetails.vue";

export default {
  components: {
    Details,
  },
};
</script>
